/** 金額をフォーマットする（例: 12345 → "¥12,345"） */
export const formatAmount = (amount: number): string => {
	return `¥${Number(amount).toLocaleString()}`
}

/** nullable な金額をフォーマットする（null の場合は "¥0"） */
export const formatNullableAmount = (
	amount: number | null | undefined
): string => {
	if (amount == null) return "¥0"
	return `¥${Number(amount).toLocaleString()}`
}
